<template>
  <div>
    <StandardCard :title="schedule.processName" subheader="INFO">
      <template v-slot>
        <CardContent v-model="info" />
      </template>
    </StandardCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";

export default Vue.extend({
  name: "CheckupInfoCard",
  props: {
    schedule: {
      type: Object,
    },
    activities: {
      type: Array,
    },
  },
  computed: {
    info(): Array<any> {
      var data = [
        {
          icon: "mdi-folder-pound-outline",
          title: "Id",
          content: this.schedule?.id,
        },
        {
          icon: "mdi-account-tie-outline",
          title: "Ansvarlig",
          content: this.schedule?.responsiblePersonFullName,
        },
        {
          icon: "mdi-autorenew",
          title: "Status",
          content: this.activitiesStatus,
        },
        {
          icon: "mdi-calendar",
          title: "Oppstart",
          content: this.schedule?.startDate
            ? moment(this.schedule?.startDate).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-calendar-alert",
          title: "Frist",
          content: this.schedule?.endDate
            ? moment(this.schedule?.endDate).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-account-group-outline",
          title: "Fagområde",
          content: this.schedule?.tradeCode,
        },
        {
          icon: "mdi-home-city-outline",
          title: "Prosjekt",
          content: this.schedule?.projectName,
        },
      ];
      if (this.schedule?.houseNum) {
        data.push({
          icon: "mdi-home-outline",
          title: "Bygg",
          content: this.schedule?.houseNum,
        });
      }

      return data;
    },
    activitiesStatus(): string {
      var status = "";
      var done = (this as any).activities.reduce(
        (counter, { complete }) => (complete ? (counter += 1) : counter),
        0
      );
      status = done + " / " + (this as any).activities.length;

      return status;
    },
  },
  components: {
    StandardCard,
    CardContent,
  },
});
</script>
